import React, { useState } from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

export const FilterContext = React.createContext({
  allBikes: [],
  filteredBikes: [],
  setFilteredBikes: bikes => bikes,
  filters: {},
  setFilters: filters => filters,
})

const FilterProvider = props => {
  const [filteredBikes, setFilteredBikes] = useState([])
  const [filters, setFilters] = useState({})

  const handleSetFilteredBikes = newBikes => {
    setFilteredBikes(newBikes)
  }

  const handleSetFilters = newFilters => {
    setFilters(newFilters)
  }

  return (
    <StaticQuery
      query={graphql`
        query {
          allContentfulProduct {
            edges {
              node {
                images {
                  fluid {
                    ...GatsbyContentfulFluid_noBase64
                  }
                }
                brand
                engine
                inStock
                name
                tags
                prices {
                  prices {
                    price
                    battery
                  }
                }
                leasingRabatt
                kjopeRabatt
              }
            }
          }
        }
      `}
      render={data => {
        return (
          <FilterContext.Provider
            value={{
              allBikes: data.allContentfulProduct.edges.map(b => b.node),
              filteredBikes,
              setFilteredBikes: handleSetFilteredBikes,
              filters,
              setFilters: handleSetFilters,
            }}
          >
            {props.children}
          </FilterContext.Provider>
        )
      }}
    />
  )
}

FilterProvider.propTypes = {
  children: PropTypes.node,
}

export default FilterProvider
